// @flow
import styled from 'styled-components';

export const List = styled.ol`
    position: relative;
    list-style: none;
    padding: 0;
    margin: 1.5em 0;
    text-align: left;
`;

export const Item = styled.li`
    counter-increment: step-counter;
    line-height: 2em;
    margin: 0 0 1em 3em;
    padding: 0;

    &:before {
        content: counter(step-counter);
        position: absolute;
        left: 0;
        border: 1px solid ${({ theme }) => theme.mediumGrey};
        width: 2em;
        height: 2em;
        border-radius: 2em;
        text-align: center;
        vertical-align: middle;
    }
`;



// WEBPACK FOOTER //
// ./src/components/widgets/numbered-list/styles.js